import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { ActiveManagementFiltersValues } from '@/utils/constants'

export const mapActiveManagementFiltersSaveParams = (
    validActiveFilters: ActiveManagementFiltersValues
) => {
    const timelineValue = parseTimelineFilter(validActiveFilters.timeline)

    const baseParams = {
        nodeIds: validActiveFilters.node,
        tagIds: validActiveFilters.tag,
        facilityIds: validActiveFilters.facility,
        usnAccountIds: validActiveFilters.usn,
        meterIds: validActiveFilters.meter,
        subMeterIds: validActiveFilters.subMeter,
    }

    if (validActiveFilters.timeline.type === 'is') {
        return {
            ...baseParams,
            timeline: validActiveFilters.timeline.value,
        }
    } else {
        return {
            ...baseParams,
            startDate: timelineValue.startDate,
            endDate: timelineValue.endDate,
        }
    }
}
